
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"24","viewBox":"0 0 22 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22 12a10.96 10.96 0 01-.425 3h-2.1A8.912 8.912 0 0020 12a9.01 9.01 0 00-9-9 8.891 8.891 0 00-4.654 1.314L8.2 7H1.209l2.152-7 1.85 2.673A10.967 10.967 0 0122 12zm-6.354 7.692A8.9 8.9 0 0111 21 8.975 8.975 0 012.525 9h-2.1A10.969 10.969 0 0016.78 21.333L18.633 24l2.152-6.989h-6.994l1.855 2.681zM12 12V6h-2v8h7v-2z"}})])
          )
        }
      }
    